// Mobile menu & header scroll
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('.site-header');
    var burger = document.getElementById('burger');
    var nav = document.getElementById('site-nav');

    // Scroll behaviour
    if (header) {
      var scrolled = false;
      window.addEventListener('scroll', function () {
        var isScrolled = window.scrollY > 30;
        if (isScrolled !== scrolled) {
          scrolled = isScrolled;
          header.classList.toggle('scrolled', scrolled);
        }
      }, { passive: true });
    }

    // Burger toggle
    if (burger && nav) {
      function closeNav() {
        nav.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        // Restore header z-index (was raised so burger stays above overlay)
        if (header) header.style.zIndex = '';
      }

      burger.addEventListener('click', function () {
        var open = nav.classList.toggle('open');
        burger.classList.toggle('open', open);
        burger.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
        // Raise header above nav overlay (z-index:1003) so burger is clickable
        if (header) header.style.zIndex = open ? '1004' : '';
      });

      // Close on nav link click
      nav.querySelectorAll('.nav-link').forEach(function (link) {
        link.addEventListener('click', function () { closeNav(); });
      });

      // Close on overlay background click (click on nav itself, not its children)
      nav.addEventListener('click', function (e) {
        if (e.target === nav) { closeNav(); }
      });
    }

    // Language switcher dropdown
    var langToggles = document.querySelectorAll('.lang-switcher');
    langToggles.forEach(function (switcher) {
      var toggle = switcher.querySelector('.lang-switcher__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        switcher.classList.toggle('open');
      });

      document.addEventListener('click', function () {
        switcher.classList.remove('open');
      });
    });

    // Active nav link
    var currentPath = window.location.pathname;
    document.querySelectorAll('.nav-link').forEach(function (link) {
      var href = link.getAttribute('href');
      if (href && currentPath.endsWith(href)) {
        link.classList.add('active');
      }
    });
  });
}());
